import { FC } from 'react';
import Icon from 'Components/Icon';

interface PriceReasonIconProps {
  reason: string;
}

export const PriceReasonIcon: FC<PriceReasonIconProps> = ({ reason }) => {
  return (
    <span className="tw tw:inline-flex tw:items-center tw:gap-1">
      <Icon name="warning" size="small" className="tw:text-red-600" />
      <span className="tw:text-xs tw:text-gray-600">{reason}</span>
    </span>
  );
};
